import Vue from 'vue'
import Router from 'vue-router'
import index from '@/views/index'
import news from '@/views/news'
import detail from '@/views/news/detail'
import about from '@/views/about'
import szfw from '@/views/szfw'
import bmtd from '@/views/bmtd'
import kcsz from '@/views/kcsz'
import alfx from '@/views/alfx'
import onlineing from '@/views/onlineing'
Vue.use(Router)

export default new Router({
  //mode: 'history', 
  // linkActiveClass: 'is-actived', 
  routes: [
    {
      path: '/',
      name: 'index',
      component: index      
    }
    ,
    {
      path: '/kcsz',
      name: 'kcsz',
      component: kcsz
    },
    {
      path: '/szfw',
      name: 'szfw',
      component: szfw
    },
    {
      path: '/alfx',
      name: 'alfx',
      component: alfx
    },
    {
      path: '/onlineing',
      name: 'onlineing',
      component: onlineing
    },
    {
      path: '/news',
      name: 'news',
      component: news
    },
    {
      path: '/news/detail',
      name: 'detail',
      component: detail
    },
    {
      path: '/about',
      name: 'about',
      component: about
    },
    {
      path: '/bmtd',
      name: 'bmtd',
      component: bmtd
    }    
  ]
})
const VueRouterPush = Router.prototype.push
Router.prototype.push = function push (to) {
  return VueRouterPush.call(this, to).catch(err => err)
}


// WEBPACK FOOTER //
// ./src/router/index.js